import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { OG_IMAGE, absoluteUrl, pageForPath } from '../seo/pages';

function upsertMeta(attribute, key, content) {
    const selector = `meta[${attribute}="${key}"]`;
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
}

function upsertCanonical(href) {
    let element = document.head.querySelector('link[rel="canonical"]');
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', 'canonical');
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
}

function PageMeta() {
    const { pathname } = useLocation();
    const page = pageForPath(pathname);

    useEffect(() => {
        const url = absoluteUrl(page.canonicalPath);
        document.title = page.title;
        upsertMeta('name', 'description', page.description);
        upsertMeta('property', 'og:title', page.title);
        upsertMeta('property', 'og:description', page.description);
        upsertMeta('property', 'og:url', url);
        upsertMeta('property', 'og:type', 'website');
        upsertMeta('property', 'og:image', OG_IMAGE);
        upsertMeta('name', 'twitter:card', 'summary_large_image');
        upsertMeta('name', 'twitter:title', page.title);
        upsertMeta('name', 'twitter:description', page.description);
        upsertMeta('name', 'twitter:image', OG_IMAGE);
        upsertCanonical(url);
    }, [page]);

    return null;
}

export default PageMeta;
